import React from 'react';
import { GraduationCap } from 'lucide-react';

/* Student-facing display of a teacher's remark (inline styles so it fits the
   CELPIP-styled Results page). */
const when = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' });
};

export default function TeacherRemark({ comment, title = 'Remark from your teacher', testId = 'teacher-remark', compact = false }) {
  if (!comment || !comment.text) return null;
  return (
    <div data-testid={testId} style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderLeft: '4px solid #f59e0b', borderRadius: '8px', padding: compact ? '10px 14px' : '14px 18px', margin: compact ? '0' : '0 0 12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap', marginBottom: '6px' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: 700, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          <GraduationCap size={14} /> {title}
        </span>
        <span style={{ fontSize: '11px', color: '#b45309' }} data-testid={`${testId}-meta`}>{comment.author_name || 'Your teacher'}{comment.updated_at ? ` · ${when(comment.updated_at)}` : ''}</span>
      </div>
      <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.65', color: '#1f2937', whiteSpace: 'pre-wrap' }} data-testid={`${testId}-text`}>{comment.text}</p>
    </div>
  );
}
